var copyEls = Array.prototype.slice.call(document.querySelectorAll('.copy-item'));
var bitcoinMetaEl = document.getElementById('bitcoin-price-meta');
var bitcoinUpdatedEl = bitcoinMetaEl ? bitcoinMetaEl.querySelector('.price-meta__updated') : null;
var bitcoinSourceEl = bitcoinMetaEl ? bitcoinMetaEl.querySelector('.price-meta__source') : null;
var priceEls = Array.prototype.slice.call(document.querySelectorAll('.price[data-price-usd]'));
var CLEAR_MS = 3000;
var activePop = null;
var clearTimer = null;
var BITCOIN_PRICE_URL = '/asset/bitcoin/bitcoin-usd-close.json';
var BITCOIN_SOURCE_PREFIX = 'Aggregate average price from ';
var BITCOIN_EXCHANGE_META = {
  Coinbase: { icon: 'coinbase' },
  CoinGecko: { icon: 'coingecko' },
  Kraken: { icon: 'kraken' },
  Gemini: { icon: 'gemini' },
  Bitfinex: { icon: 'bitfinex' },
  OKX: { icon: 'okx' },
  KuCoin: { icon: 'kucoin' }
};

function showPopup(anchorEl, msg) {
  if (activePop) { activePop.remove(); activePop = null; }
  var pop = document.createElement('div');
  pop.className = 'copy-pop';
  pop.setAttribute('role', 'status');
  pop.setAttribute('aria-live', 'polite');
  pop.textContent = msg || 'Copied!';
  document.body.appendChild(pop);

  // Position centered above the anchor; clamp to viewport
  var r = anchorEl.getBoundingClientRect();
  var vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  var vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

  // First paint to get size
  pop.style.left = '0px'; pop.style.top = '0px';
  var pw = pop.offsetWidth; var ph = pop.offsetHeight;

  var left = Math.round(r.left + r.width / 2 - pw / 2);
  var top  = Math.round(r.top - ph - 10);

  // Fallback below if not enough space above
  if (top < 8) top = Math.min(Math.round(r.bottom + 10), vh - ph - 8);

  // Clamp horizontally
  left = Math.max(8, Math.min(left, vw - pw - 8));

  pop.style.left = left + 'px';
  pop.style.top  = top + 'px';

  // Animate in
  requestAnimationFrame(function(){ pop.classList.add('show'); });

  activePop = pop;
  if (clearTimer) clearTimeout(clearTimer);
  clearTimer = setTimeout(function () {
    if (!activePop) return;
    activePop.classList.remove('show');
    // Wait for transition then remove
    setTimeout(function(){ if (activePop) { activePop.remove(); activePop = null; } }, 180);
  }, CLEAR_MS);
}

function copyText(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text);
  }
  var ta = document.createElement('textarea');
  ta.value = text; ta.setAttribute('readonly','');
  ta.style.position = 'fixed'; ta.style.left = '-9999px'; ta.style.top = '0';
  document.body.appendChild(ta);
  ta.select(); ta.setSelectionRange(0, ta.value.length);
  try { document.execCommand('copy'); } finally { document.body.removeChild(ta); }
  return Promise.resolve();
}

function htmlToText(value) {
  var tempEl;
  if (!value) return '';
  tempEl = document.createElement('div');
  tempEl.innerHTML = String(value);
  return (tempEl.textContent || tempEl.innerText || '').replace(/\s+/g, ' ').trim();
}

function getCopyText(copyEl) {
  var priceEl;
  var titleEl;
  var listingTitleEl;
  var categoryEl;
  var prefixText;
  var categoryText;
  var listingText;
  var itemText;
  var fallbackText;

  fallbackText = htmlToText(copyEl.getAttribute('data-copy-prefix') || copyEl.getAttribute('data-copy-text') || copyEl.textContent || '');
  priceEl = copyEl.closest('.price');
  titleEl = priceEl ? priceEl.querySelector('.price__title') : null;
  listingTitleEl = document.querySelector('#main h1.hero-title');
  categoryEl = document.querySelector('.breadcrumb-item:nth-last-child(2) a, .breadcrumb-item:nth-last-child(2) span');
  prefixText = htmlToText(copyEl.getAttribute('data-copy-prefix') || '');
  categoryText = htmlToText(categoryEl ? categoryEl.textContent : '');
  listingText = htmlToText(listingTitleEl ? listingTitleEl.childNodes[0] && listingTitleEl.childNodes[0].nodeType === 3 ? listingTitleEl.childNodes[0].textContent : listingTitleEl.textContent : '');
  itemText = htmlToText(titleEl ? titleEl.textContent : '');

  if (prefixText && itemText) {
    return prefixText + ' - ' + itemText;
  }
  if (categoryText && listingText && itemText) {
    return categoryText + ' - ' + listingText + ' - ' + itemText;
  }
  return fallbackText;
}

function handleCopy(copyEl) {
  var text = getCopyText(copyEl);
  if (!text) return;
  copyText(text).then(function () {
    showPopup(copyEl, 'Copied!');
  }).catch(function () {
    showPopup(copyEl, 'Press Ctrl+C to copy');
  });
}

copyEls.forEach(function (copyEl) {
  copyEl.addEventListener('click', function () {
    handleCopy(copyEl);
  });
});

function formatNumber(value, options) {
  return new Intl.NumberFormat('en-US', options).format(value);
}

function formatBtc(value) {
  return formatNumber(value, {
    minimumFractionDigits: 8,
    maximumFractionDigits: 8
  }) + ' BTC';
}

function formatLastModified(value) {
  var date = new Date(value);
  if (isNaN(date.getTime())) return null;
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short'
  }).format(date);
}

function isStale(value, staleAfterHours) {
  var date = new Date(value);
  var hours = Number(staleAfterHours);
  if (isNaN(date.getTime()) || !isFinite(hours) || hours <= 0) return false;
  return (Date.now() - date.getTime()) > (hours * 60 * 60 * 1000);
}

function setBitcoinSource(sourceText) {
  var exchangeText;
  var exchangeNames;
  var prefixEl;
  var listEl;
  var punctuationEl;

  if (!bitcoinSourceEl) return;

  if (!sourceText) {
    bitcoinSourceEl.textContent = '';
    return;
  }

  if (sourceText.indexOf(BITCOIN_SOURCE_PREFIX) !== 0 || sourceText.charAt(sourceText.length - 1) !== '.') {
    bitcoinSourceEl.textContent = sourceText;
    return;
  }

  exchangeText = sourceText.slice(BITCOIN_SOURCE_PREFIX.length, -1).trim();
  exchangeNames = exchangeText ? exchangeText.split(/\s*,\s*/) : [];

  if (!exchangeNames.length) {
    bitcoinSourceEl.textContent = sourceText;
    return;
  }

  bitcoinSourceEl.textContent = '';

  prefixEl = document.createElement('span');
  prefixEl.className = 'price-meta__source-prefix';
  prefixEl.textContent = BITCOIN_SOURCE_PREFIX;
  bitcoinSourceEl.appendChild(prefixEl);

  listEl = document.createElement('span');
  listEl.className = 'price-meta__source-list';
  bitcoinSourceEl.appendChild(listEl);

  exchangeNames.forEach(function (exchangeName, index) {
    var exchangeMeta = BITCOIN_EXCHANGE_META[exchangeName];
    var exchangeEl = document.createElement('span');
    var nameEl = document.createElement('span');

    exchangeEl.className = 'price-meta__exchange';

    if (exchangeMeta && exchangeMeta.icon) {
      exchangeEl.className += ' font-icon--color--inventory-item--' + exchangeMeta.icon + '--background';
      var iconEl = document.createElement('span');
      iconEl.className = 'price-meta__exchange-icon font-icon--inventory-item--' + exchangeMeta.icon;
      iconEl.setAttribute('aria-hidden', 'true');
      exchangeEl.appendChild(iconEl);
    }

    nameEl.className = 'price-meta__exchange-name';
    nameEl.textContent = exchangeName;
    exchangeEl.appendChild(nameEl);
    listEl.appendChild(exchangeEl);

    if (index < exchangeNames.length - 1) {
      var separatorEl = document.createElement('span');
      separatorEl.className = 'price-meta__source-separator';
      separatorEl.textContent = ', ';
      listEl.appendChild(separatorEl);
    }
  });

  punctuationEl = document.createElement('span');
  punctuationEl.className = 'price-meta__source-punctuation';
  punctuationEl.textContent = '.';
  bitcoinSourceEl.appendChild(punctuationEl);
}

function showBitcoinMeta(message, sourceText) {
  if (!bitcoinMetaEl) return;
  if (bitcoinUpdatedEl) {
    bitcoinUpdatedEl.textContent = message || '';
  }
  if (bitcoinSourceEl) {
    setBitcoinSource(sourceText || '');
  }
  bitcoinMetaEl.hidden = false;
}

function showUnavailablePricing() {
  priceEls.forEach(function (priceEl) {
    showUnavailablePrice(priceEl);
  });
}

function showUnavailablePrice(priceEl) {
  var bitcoinBlock = priceEl.querySelector('.price__bitcoin');
  var btcEl = priceEl.querySelector('.price__bitcoin-btc');

  if (!bitcoinBlock || !btcEl) return;

  btcEl.textContent = 'Price Currently Unavailable';
  bitcoinBlock.hidden = false;
}

function populateBitcoinPricing(payload) {
  if (!payload || typeof payload !== 'object') {
    showUnavailablePricing();
    showBitcoinMeta('Bitcoin reference pricing is temporarily unavailable.', '');
    return;
  }
  if (isStale(payload.last_modified, payload.stale_after_hours)) {
    showUnavailablePricing();
    showBitcoinMeta('Bitcoin reference pricing is temporarily unavailable because the cached data is stale.', payload.source || '');
    return;
  }
  var bitcoinUsd = Number(payload.bitcoin_usd);
  if (!isFinite(bitcoinUsd) || bitcoinUsd <= 0) {
    showUnavailablePricing();
    showBitcoinMeta('Bitcoin reference pricing is temporarily unavailable.', payload.source || '');
    return;
  }

  priceEls.forEach(function (priceEl) {
    var usdValue = Number(priceEl.getAttribute('data-price-usd'));
    if (!isFinite(usdValue) || usdValue <= 0) {
      showUnavailablePrice(priceEl);
      return;
    }

    var btcValue = usdValue / bitcoinUsd;
    var bitcoinBlock = priceEl.querySelector('.price__bitcoin');
    var btcEl = priceEl.querySelector('.price__bitcoin-btc');

    if (!bitcoinBlock || !btcEl) return;

    btcEl.textContent = formatBtc(btcValue);
    bitcoinBlock.hidden = false;
  });

  if (bitcoinMetaEl) {
    var formattedLastModified = formatLastModified(payload.last_modified);
    var formattedClosingDatetime = formatLastModified(payload.closing_datetime);
    if (bitcoinUpdatedEl && (formattedClosingDatetime || formattedLastModified)) {
      if (formattedClosingDatetime && formattedLastModified) {
        bitcoinUpdatedEl.textContent = 'Bitcoin close time ' + formattedClosingDatetime + '. Updated ' + formattedLastModified + '.';
      }
      else if (formattedClosingDatetime) {
        bitcoinUpdatedEl.textContent = 'Bitcoin close time ' + formattedClosingDatetime + '.';
      }
      else {
        bitcoinUpdatedEl.textContent = 'Bitcoin reference updated ' + formattedLastModified + '.';
      }
    }
    if (bitcoinSourceEl && payload.source) {
      setBitcoinSource(payload.source);
    }
    bitcoinMetaEl.hidden = false;
  }
}

if (priceEls.length) {
  fetch(BITCOIN_PRICE_URL, {
    credentials: 'same-origin'
  })
    .then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.json();
    })
    .then(populateBitcoinPricing)
    .catch(function () {
      showUnavailablePricing();
      showBitcoinMeta('Bitcoin reference pricing is temporarily unavailable.', '');
    });
}
